import React from 'react';
import { motion } from 'framer-motion';

import bioark from '../img/partners/bioark.png';
import venturekick from '../img/partners/venturekick.png';
import innosuisse from '../img/partners/innosuisse.png';
import swissBiotech from '../img/partners/swiss_biotech_association.png';
import institutCurie from '../img/partners/institut_curie.png';
import hesso from '../img/partners/hesso.png';

const partners = [
  { name: "BioArk", url: "https://bioark.ch/", logo: bioark },
  { name: "Venture Kick", url: "https://www.venturekick.ch/", logo: venturekick },
  { name: "Innosuisse", url: "https://www.innosuisse.admin.ch/fr", logo: innosuisse },
  { name: "Swiss Biotech", url: "https://www.swissbiotech.org/", logo: swissBiotech },
  { name: "Institut Curie", url: "https://curie.fr/", logo: institutCurie },
  { name: "HES-SO Valais-Wallis", url: "https://www.hevs.ch/fr", logo: hesso }
];

const PartnersSection = () => {
  return (
    <section id="partners" className="py-20 md:py-32 relative bg-ninsun-surface border-y border-gray-200">
      <div className="container mx-auto px-6 text-center">
        
        <h2 className="text-3xl md:text-4xl font-display font-bold text-ninsun-text mb-16 tracking-tight">Our Partners</h2>
        
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 max-w-6xl mx-auto">
          {partners.map((partner, index) => (
            <motion.a 
              key={index}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100 hover:scale-105"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <img 
                src={partner.logo} 
                alt={partner.name} 
                className="max-h-20 w-auto object-contain"
              />
            </motion.a>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PartnersSection;